

import TiwiMixin from '../mixins/TiwiMixin';

export default {
  mixins: [TiwiMixin],
  props: {
    showModal: {
      required: true,
      default: false,
      type: Boolean
    },
    isYoutubeVideoModal: {
      required: false,
      default: false,
      type: Boolean
    },
    modalId: {
      required: true,
      default: false,
      type: String
    },
    modalTitle: {
      required: false,
      type: String
    },
    onClose: {
      required: true,
      default: false,
      type: Function
    },
    containerClass: {
      required: false,
      default: 'wider',
      type: String
    },
  },
  data() {
    return {

    }
  },
  mounted: function () {
    this.modal_window = new bootstrap.Modal('#' + this.modalId);
    if (this.showModal) {
      this.modal_window.show();
    }
  },
  methods: {
    openModal: function () {
      this.modal_window.show();
    },
    closeModal: function () {
      this.modal_window.hide();
      this.onClose();
    },
  },
  computed: {

  },
  watch: {
    showModal: function (show, old) {
      if (show) {
        this.openModal();
      } else {
        this.closeModal();
      }
    }
  }
}
